export default __webpack_public_path__ + "static/media/cwr.90341240.svg";